import { useEffect } from 'react';
import { Heading2 } from '../../components/shared/Heading';
import { useRootStore } from '../../stores/useRootStore';
import { observer } from 'mobx-react-lite';
import { WithOrderSummaryLayout } from '../../components/WithOrderSummaryLayout';
import { useRedirectToHomePage } from '../../useRedirectToHomePage';
import { Navigate } from 'react-router-dom';
import { OrderSummary } from '../OrderSummary';
import { ServiceList } from './ServiceList';
import { useSummaryParams } from '../../utils/useSummaryParams';
import { BackLink } from '../../components/shared/BackButton/BackLink';

export const ServicesPage = observer(() => {
  const { paramsStore, configStore } = useRootStore();

  useRedirectToHomePage();

  useEffect(() => {
    paramsStore.fetchServices();
  }, [paramsStore]);

  const params = useSummaryParams(paramsStore);

  return (
    <WithOrderSummaryLayout
      showButton
      sideContent={closeDialog => (
        <OrderSummary
          onClose={closeDialog}
          serviceStore={paramsStore.serviceStore}
          params={params}
          showServices
        />
      )}
    >
      <div>
        {configStore.shoudSkipServices && <Navigate to="/form" replace />}
        <BackLink to="/rates">К выбору тарифа</BackLink>
        <Heading2 className="mt-8">Дополнительные услуги</Heading2>

        <ServiceList
          serviceStore={paramsStore.serviceStore}
          params={paramsStore.appliedParams?.range ?? {}}
        />
      </div>
    </WithOrderSummaryLayout>
  );
});
